// Copyright (c) 2016 Deere & Company

import ClaimDetailsContainer from './claim-details-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claim: state.claims.parts.claim,
    formValidation: state.claims.parts.formValidation,
    isEditable: state.claims.parts.isEditable,
    isValidClaim: state.claims.parts.isValidClaim,
    ownershipStatus: state.claims.ownershipStatus,
    product: state.claims.parts.product,
    rgaStatus: state.claims.parts.claim.rgaStatus,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClaimDetailsContainer);



// WEBPACK FOOTER //
// ./src/claim/parts/components/claim-details-section/index.js